(function () {
  "use strict";

  var rules = {};
  var messages = {
    min: "Minimum order quantity: {min}.",
    step: "This item is sold from {min} and then in steps of {step}."
  };
  var busy = false;
  var timer = null;

  function readData() {
    var el = document.getElementById("moq-data");
    if (!el) {
      return;
    }
    var data;
    try {
      data = JSON.parse(el.textContent);
    } catch (error) {
      return;
    }
    if (data.messages) {
      messages = data.messages;
    }
    var list = data.rules || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].min > 0 || list[i].step > 0) {
        rules[String(list[i].id)] = { min: list[i].min, step: list[i].step };
      }
    }
  }

  function getRule(variantId) {
    if (!variantId) {
      return null;
    }
    return rules[String(variantId)] || null;
  }

  function minimumOf(rule) {
    return rule.min > 0 ? rule.min : rule.step;
  }

  function stepOf(rule) {
    return rule.step > 0 ? rule.step : 1;
  }

  function isValidQuantity(quantity, rule) {
    var minimum = minimumOf(rule);
    if (quantity < minimum) {
      return false;
    }
    return (quantity - minimum) % stepOf(rule) === 0;
  }

  function fixQuantity(quantity, rule) {
    var minimum = minimumOf(rule);
    var step = stepOf(rule);
    if (quantity <= minimum) {
      return minimum;
    }
    return minimum + Math.ceil((quantity - minimum) / step) * step;
  }

  function messageFor(rule) {
    var minimum = minimumOf(rule);
    var step = stepOf(rule);
    var template = step > 1 ? messages.step : messages.min;
    return template
      .replace(/{min}/g, minimum)
      .replace(/{step}/g, step)
      .replace(/{next2}/g, minimum + step * 2)
      .replace(/{next}/g, minimum + step);
  }

  function isQuantityInput(input) {
    if (!input || input.tagName !== "INPUT") {
      return false;
    }
    var name = input.getAttribute("name") || "";
    return name === "quantity" || name.indexOf("updates[") === 0;
  }

  function variantIdOf(input) {
    if (input.dataset && input.dataset.quantityVariantId) {
      return input.dataset.quantityVariantId;
    }

    var name = input.getAttribute("name") || "";
    var match = name.match(/updates\[([^\]]+)\]/);
    if (match) {
      var key = match[1].split(":")[0];
      if (/^\d+$/.test(key)) {
        return key;
      }
    }

    var holder = input.closest("[data-variant-id]");
    if (holder) {
      return holder.getAttribute("data-variant-id");
    }

    var row = input.closest(
      "tr, li, .cart-item, .cart__row, .cart-drawer-item, [class*='cart-item']"
    );
    if (row) {
      var link = row.querySelector('a[href*="variant="]');
      if (link) {
        var linkMatch = link.getAttribute("href").match(/variant=(\d+)/);
        if (linkMatch) {
          return linkMatch[1];
        }
      }
      var keyed = row.querySelector("[data-line-item-key], [data-key]");
      if (keyed) {
        var raw =
          keyed.getAttribute("data-line-item-key") ||
          keyed.getAttribute("data-key") ||
          "";
        var first = raw.split(":")[0];
        if (/^\d+$/.test(first)) {
          return first;
        }
      }
    }

    if (name === "quantity") {
      var form = input.form || input.closest("form");
      if (form) {
        var hidden = form.querySelector('[name="id"]');
        if (hidden && hidden.value) {
          return hidden.value;
        }
      }
      var anyHidden = document.querySelector(
        'form[action*="/cart/add"] [name="id"]'
      );
      if (anyHidden) {
        return anyHidden.value;
      }
    }

    return null;
  }

  function wrapperOf(input) {
    var start = input.parentElement;
    if (!start) {
      return input;
    }
    var found = start.closest(".quantity-selector--wrapper");
    return found || start;
  }

  function showMessage(input, text) {
    var anchor = wrapperOf(input);
    var box = anchor.nextElementSibling;
    if (!box || box.className !== "moq-message") {
      box = document.createElement("div");
      box.className = "moq-message";
      anchor.insertAdjacentElement("afterend", box);
    }
    if (box.textContent !== text) {
      box.textContent = text;
    }
  }

  function hideMessage(input) {
    var box = wrapperOf(input).nextElementSibling;
    if (box && box.className === "moq-message") {
      box.parentNode.removeChild(box);
    }
  }

  function applyRule(input) {
    var rule = getRule(variantIdOf(input));
    if (!rule) {
      hideMessage(input);
      return;
    }
    input.setAttribute("min", minimumOf(rule));
    input.setAttribute("step", stepOf(rule));
    var quantity = parseInt(input.value, 10);
    if (isNaN(quantity)) {
      quantity = 0;
    }
    if (!isValidQuantity(quantity, rule)) {
      input.value = fixQuantity(quantity, rule);
    }
    showMessage(input, messageFor(rule));
  }

  function refresh() {
    busy = true;
    var inputs = document.querySelectorAll(
      'input[name="quantity"], input[name^="updates["]'
    );
    for (var i = 0; i < inputs.length; i++) {
      try {
        applyRule(inputs[i]);
      } catch (error) {
        break;
      }
    }
    setTimeout(function () {
      busy = false;
    }, 0);
  }

  function schedule() {
    if (timer) {
      return;
    }
    timer = setTimeout(function () {
      timer = null;
      refresh();
    }, 300);
  }

  function onChangeCapture(event) {
    var input = event.target;
    if (!isQuantityInput(input)) {
      return;
    }
    var rule = getRule(variantIdOf(input));
    if (!rule) {
      return;
    }
    var quantity = parseInt(input.value, 10);
    if (isNaN(quantity)) {
      quantity = 0;
    }
    if (!isValidQuantity(quantity, rule)) {
      input.value = fixQuantity(quantity, rule);
      try {
        showMessage(input, messageFor(rule));
      } catch (error) {
        return;
      }
    }
  }

  function onChangeBubble(event) {
    if (!isQuantityInput(event.target)) {
      schedule();
    }
  }

  function watch() {
    if (!window.MutationObserver || !document.body) {
      return;
    }
    var observer = new MutationObserver(function (records) {
      if (busy) {
        return;
      }
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) {
          schedule();
          return;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    readData();
    refresh();
    watch();
    document.addEventListener("change", onChangeCapture, true);
    document.addEventListener("change", onChangeBubble);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();